var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BatchTable',{attrs:{"orderInspectionCode":_vm.orderInspectionCode,"changeOrderCode":_vm.changeOrderCode,"disabled":_vm.disabled,"isExpand":""},on:{"reload":function($event){return _vm.$emit('reload')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }